"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartNewsletterSubscribeAndAcceptTermsConditions = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
const labelToCheckboxElementMap = {
    [enums_1.EventLabelCartBoxClickEnum.SubscribeToNewsletter]: 'subscribe to newsletter',
    [enums_1.EventLabelCartBoxClickEnum.AcceptTermsAndConditions]: 'accept terms and conditions',
};
function trackCartNewsletterSubscribeAndAcceptTermsConditions(label) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: enums_1.ClickEventType.BOX_CLICK,
        eventLabel: label,
        eventData: {
            eventName: enums_1.GA4EventName.SelectCheckBox,
            feature_category: enums_1.GA4FeatureCategory.Cart,
            checkbox_element: labelToCheckboxElementMap[label],
        },
    });
}
exports.trackCartNewsletterSubscribeAndAcceptTermsConditions = trackCartNewsletterSubscribeAndAcceptTermsConditions;
//# sourceMappingURL=trackCartNewsletterSubscribeAndAcceptTermsConditions.js.map